let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gDiIK"), load("eLlpV"), load("f1B4n"), load("7sItg"), load("1Tuyb"), load("7iCpI")]).then(() => parcelRequire('3n8T5'));